var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiBet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1431 0.666687C18.8795 0.666687 19.4765 1.26364 19.4765 2.00002L19.476 5.37602L20.1443 4.42556C20.5342 3.86875 21.2726 3.70101 21.8583 4.0107L22.0012 4.09812L27.4623 7.92197C28.0191 8.31185 28.1868 9.05024 27.8771 9.63597L27.7897 9.77894L20.9068 19.6088C20.5169 20.1656 19.7785 20.3333 19.1928 20.0236L19.0498 19.9362L14.3787 16.6667H13.6453L8.98113 19.9362C8.37793 20.3586 7.54653 20.212 7.12416 19.6088L0.241245 9.77894C-0.181125 9.17573 -0.0345279 8.34434 0.568679 7.92197L6.02969 4.09812C6.6329 3.67575 7.46429 3.82235 7.88666 4.42556L8.80933 5.74488V8.07021L6.79446 5.19033L1.33345 9.01417L8.21636 18.844L11.3213 16.6667H10.1431C9.40676 16.6667 8.80981 16.0697 8.80981 15.3334V2.00002C8.80981 1.26364 9.40676 0.666687 10.1431 0.666687H18.1431ZM21.2365 5.19033L19.476 7.70135L19.4765 15.3334C19.4765 16.0697 18.8795 16.6667 18.1431 16.6667H16.7067L19.8146 18.844L26.6975 9.01417L21.2365 5.19033ZM18.1431 2.00002H10.1431V15.3334H18.1431V2.00002Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiBet);
export default __webpack_public_path__ + "static/media/multi-bet.b3bd0b885e75d9340d6334389d2fac36.svg";
export { ForwardRef as ReactComponent };